module.exports = __webpack_public_path__ + "img/blue_106.2218be30.png";